import Chart from 'chart.js/auto';

export const createChart = (canvas, theme) => {
  const ctx = canvas.getContext('2d');
  const rootStyles = getComputedStyle(document.documentElement);
  const isDark = theme === 'dark' || document.documentElement.classList.contains('dark');
  const textColor = isDark
    ? '#f7f7f8'
    : rootStyles.getPropertyValue('--text-color').trim() || '#0a0a0a';
  const gridColor = isDark
    ? '#2a2a2e'
    : rootStyles.getPropertyValue('--chart-grid-color').trim() || '#ececee';
  const primaryColor = rootStyles.getPropertyValue('--primary-color').trim() || '#c43a3a';
  const hoverColor = rootStyles.getPropertyValue('--hover-color').trim() || '#ad2f2f';

  return new Chart(ctx, {
    type: 'bar',
    data: {
      labels: [],
      datasets: [
        {
          label: 'Responses',
          data: [],
          backgroundColor: primaryColor,
          borderColor: hoverColor,
          borderRadius: 8,
          borderSkipped: false,
          borderWidth: 1,
          maxBarThickness: 72,
        },
      ],
    },
    options: {
      animation: false,
      maintainAspectRatio: false,
      responsive: true,
      plugins: {
        legend: {
          display: false,
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColor,
            font: {
              weight: 600,
            },
          },
          grid: {
            display: false,
          },
        },
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: 1,
            color: textColor,
          },
          grid: {
            color: gridColor,
          },
        },
      },
    },
  });
};
